export default {
      id: "ic_popular_bets-usage",
      viewBox: "0 0 24 26",
      url: "/" + "images/icons.3.109.2.svg#ic_popular_bets-usage",
      toString: function () {
        return this.url;
      }
    }